import React from 'react'
import PropTypes from 'prop-types'
import { ControlLabel } from 'react-bootstrap'

const FormLabel3 = (props) => {
  return (
    <ControlLabel htmlFor={props.for} className={props.className} id={props.id}>
      {props.children}
    </ControlLabel>
  )
}

FormLabel3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  for: PropTypes.string,
  id: PropTypes.string
}

FormLabel3.defaultProps = {
  className: ''
}

export default FormLabel3
